import smartlightLogo from '../../assets/smartlight-pdf-logo-wide.png';

function ReferralDocument({ caseId, children }) {
  return (
    <div className="rounded-lg border bg-card text-left text-sm flex flex-col min-h-full">

      {/* Logo + blue separator */}
      <div className="px-4 sm:px-8 pt-7 pb-5">
        <img src={smartlightLogo} alt="SmartLight Analytics" className="h-9 object-contain" />
        <hr className="mt-3 border-0 h-px bg-[#5b9bd5]" />
      </div>

      {children}

      {/* Footer */}
      <div className="px-4 sm:px-8 py-4 mt-auto border-t flex flex-wrap gap-y-1 items-center justify-between text-xs text-muted-foreground">
        <span>Proprietary and Confidential – Do Not Distribute</span>
        <span>Referral {caseId} | Page 1 of 1</span>
      </div>

    </div>
  );
}

function ReferralDocumentHeader({ fields }) {
  return (
    <div className="px-4 sm:px-8 pt-5 pb-5 space-y-1.5">
      {fields.map(({ label, value, large, capitalize }) => (
        <p key={label} className={large ? 'text-base font-bold text-primary' : undefined}>
          {large ? (
            `${label}: ${value}`
          ) : (
            <>
              <span className="font-bold">{label}: </span>
              <span className={capitalize ? 'capitalize' : undefined}>{value}</span>
            </>
          )}
        </p>
      ))}
    </div>
  );
}

function ReferralDocumentSection({ title, children }) {
  return (
    <div className="px-4 sm:px-8 py-5">
      <h4 className="font-bold text-primary underline mb-2">{title}</h4>
      {children}
    </div>
  );
}

export { ReferralDocument, ReferralDocumentHeader, ReferralDocumentSection };
